import { components } from "./de/components"
import { forms } from "./de/forms"
import { pages } from "./de/pages"

export const messages = {
  components: components,
  helpers: {},
  pages: pages,
  forms: forms,
}
